export default {
  inputAdornedEnd: {
    paddingTop: 15,
    paddingBottom: 14,
  },
};
